import React, { useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import styles from '../HelpSection.module.css'

const HelpActiveTenders = () => {
  const [activeKey, setActiveKey] = useState("0");

  return (
    <div className={styles.HelpAddLanes}>
      <div className={styles.HelpShortlistLsp}>
        <div className="alert alert-warning my-2">
          <h6>Note:</h6>
          <ul className="m-0 pl-2">
            <li>
              This section shows all ongoing procurements. Click{" "}
              <strong>View</strong> on any card to check details and
              participate.
            </li>
            <li>
              Procurements listed here are active. Once all rounds are
              completed, they will no longer appear in this view.
            </li>
          </ul>
        </div>
      </div>

      <Accordion
        activeKey={activeKey}
        onSelect={(eventKey) => setActiveKey(eventKey)}
      >
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                alignItems: "baseline",
              }}
            >
              <span style={{ fontWeight: "bold" }}>Active Tenders</span>
              <span style={{ fontWeight: "bolder", scale: "1.2" }}>
                {activeKey === "0" ? "▼" : "▲"}
              </span>
            </div>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="p-0">
              <h6 className="p-2">
                <strong>
                  This screen shows procurements that are currently active.
                </strong>
              </h6>
              <ul className="list-group mt-3">
                <li className="list-group-item">
                  Each procurement card includes details like:
                  <ul>
                    <li>Procurement Name</li>
                    <li>Organization Name</li>
                    <li>Current Procurement Status</li>
                  </ul>
                </li>
                <li className="list-group-item">
                  Use the <span className="badge badge-primary">View</span>{" "}
                  button to open procurement details and participate in the
                  process.
                </li>
                <li className="list-group-item">
                  All procurements displayed here are still active and have not
                  been closed. The status of the current round (if any) is shown
                  on the top-right of each card.
                </li>
                <li className="list-group-item">
                  If a live round is ongoing, you’ll see a badge like:
                  <span className="badge badge-primary ml-2">
                    Round (round no.)
                  </span>
                </li>
                <li className="list-group-item">
                  If all rounds are done and dusted, the status will show as:
                  <span className="badge badge-success ml-2">Completed</span>
                </li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default HelpActiveTenders;
